import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { environmentOf } from '../environment';
import './Login.css';

const ENDED = {
  expired: 'Your operator session expired. Sign in again.',
  revoked: 'Your operator session ended. Sign in again.',
};

export default function Login() {
  const { login, status } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      // An interrupted sign-in is reported by ConsoleNotices, from the session owner.
      if (err.name !== 'StaleAuthError') setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1>ChoreStory</h1>
          <p>Platform Administration</p>
          <p>Environment: {environmentOf(window.location.hostname)}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {ENDED[status] && <div className="login-notice" role="status">{ENDED[status]}</div>}
          {error && <div className="login-error" role="alert">{error}</div>}

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@chorestory.com"
              required
              autoFocus
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
